jQuery(function ($) {
  
var ellipsestext = "..";
if( $('.customDesc h4:first-child, .customDesc h1:first-child').length )         
{
  var height = $(".customDesc p:first-of-type").height();
   var height2 = $(".customDesc h4:first-child, .customDesc h1:first-child").height();
  $(".customDesc").css("height", height + height2 + 65 );
  $(".customDesc h4:first-child, .customDesc h1:first-child").css("margin-top", "40px" );
} else {
  var height = $(".customDesc p:first-of-type").height();
  $(".customDesc").css("height", height + 30 );
  $(".customDesc p:first-of-type").css("margin-top", "30px" );
}

var count = $(".customDesc").find("p").length;
if ( count > 1) {
  $(".customDesc p:first-of-type").append("<span class='ellipseTxt'>" + ellipsestext + "</span>");
    
  if(($('html:lang(lt) .customDesc').length)){
    $( "<div class='showMore'>Rodyti daugiau</div>" ).insertAfter( "html:lang(lt) .customDesc" );
  } 
  if (($('html:lang(lv) .customDesc').length)) {
    $( "<div class='showMore'>Lasīt vairāk</div>" ).insertAfter( "html:lang(lv) .customDesc" );
  } 
  if (($('html:lang(et) .customDesc').length)) {
     $( "<div class='showMore'>Loe rohkem</div>" ).insertAfter( "html:lang(et) .customDesc" );
  }

$(".showMore").on("click", function(){
	var $btn = $("html:lang(lt) .showMore");
    var $btn2 = $("html:lang(lv) .showMore");
    var $btn3 = $("html:lang(et) .showMore");
    var $content = $(".customDesc");
    $content.toggleClass("sized");

  if(($('html:lang(lt) .customDesc.sized').length)){
  	$btn.text("Rodyti mažiau")
  } else {
  	$btn.text("Rodyti daugiau")
  }

  if(($('html:lang(lv) .customDesc.sized').length)){
  	$btn2.text("Rādīt mazāk")
  } else {
  	$btn2.text("Lasīt vairāk")
  }

  if(($('html:lang(et) .customDesc.sized').length)){
  	$btn3.text("Näita vähem")
  } else {
  	$btn3.text("Loe rohkem")
  }
});
} else {
  $(".showMore").css("display", "none");
  (".customDesc").css("margin-bottom", "70px");
}
}); 